// Agregação de TODOS os grupos pro Breadcrumbs resolver a rota atual.
// Sidebar lateral usa Navigation/index.tsx (filtra por pathname) — não consome este index.

import dashboard from './dashboard';
import auth from './auth';
import cadastros from './cadastros';
import cofre from './cofre';
import financeiro from './financeiro';
import comercial from './comercial';
import crm from './crm';
import colaboradores from './colaboradores';
import minhaArea from './minhaArea';
import cultura from './cultura';
import helpdesk from './helpdesk';
import projetos from './projetos';
import notificacoes from './notificacoes';
import admin from './admin';

const menuItems = {
  items: [dashboard, auth, cadastros, cofre, financeiro, comercial, crm, colaboradores, minhaArea, cultura, helpdesk, projetos, notificacoes, admin]
};

export default menuItems;
